import { useEffect, useState } from "react";

export default function Admin() {
  const [users, setUsers] = useState();
  const [user, setUser] = useState();
  const [showDevice, setShowDevice] = useState(false);
  useEffect(() => {
    const getUsers = async () => {
      const response = await fetch(`https://video-api.vkpublications.com/master/users`, { method: "GET", headers: { "Content-Type": "application/json" } });
      if (response.ok) {
        await response.json().then((json) => {
          setUsers(json);
        });
      }
    };
    getUsers();
  }, []);
  const removeDevice = async (data) => {
    const response = await fetch(`https://video-api.vkpublications.com/master/reset-device`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) });
    if (response.ok) {
      setShowDevice(false);
      refreshUsers();
    }
  };
  const refreshUsers = async () => {
    const response = await fetch(`https://video-api.vkpublications.com/master/users`, { method: "GET", headers: { "Content-Type": "application/json" } });
    if (response.ok) {
      await response.json().then((json) => {
        setUsers(json);
      });
    }
  };
  return (
    <div className="admin-container">
      <table style={{ minWidth: 750, width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>User Name</th>
            <th style={{ maxWidth: 100 }}>Device Count</th>
          </tr>
        </thead>
        <tbody>
          {users?.map((m, i) => {
            return (
              <tr key={i} className="admin">
                <td>{m.name}</td>
                <td>{m.email}</td>
                <td
                  onClick={() => {
                    setUser(m);
                    setShowDevice(true);
                  }}
                  style={{ fontWeight: 700, fontSize: "1.2rem", cursor: "pointer" }}
                >
                  {m.devices?.length}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <dialog open={showDevice}>
        <div>
          <h3 style={{ color: "#797474" }}>Devices</h3>
        </div>
        <h4 style={{ margin: 0 }}>{user?.name}</h4>
        <p style={{ margin: "0 0 10px 0", fontSize: ".95rem" }}>{user?.email}</p>
        <hr />
        <table>
          <thead>
            <tr>
              <th>Book</th>
              <th>Access Code</th>
              <th>Device Id</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {user?.devices?.map((m, i) => {
              return (
                <tr key={i} className="admin">
                  <td style={{ textWrap: "nowrap", textTransform: "uppercase" }}>{m.book?.book_name}</td>
                  <td style={{ textWrap: "nowrap" }}>{m.access_code}</td>
                  <td style={{ textWrap: "nowrap" }}>{m.device_id}</td>
                  <td>
                    <button
                      onClick={() => {
                        const body = { user_id: m.user_id, device_id: m.device_id, access_code: m.access_code, book_id: m.book_id };
                        removeDevice(body);
                      }}
                      className="btn-danger"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <button
          autoFocus
          className="btn-secondary"
          onClick={() => {
            setShowDevice(false);
          }}
        >
          Close
        </button>
      </dialog>
    </div>
  );
}
